export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कुल डेबिट राशि"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कमीशन"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जानकारी"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["क्रेडिट करने के लिए"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["राशि की गणना नहीं की जा सकती"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["भुगतान के लिए अपर्याप्त धनराशि"])}
}